export const GET_CHECK_IN_CALLS = gql`
    query getCheckInCalls {
        getCheckInCalls {
            id
            createdAt
            callType
            callName
            callDescription
        }
    }
`;

export const GET_CHECK_IN_CALL = gql`
    query getCheckInCall($id: Int!) {
        getCheckInCall(id: $id) {
            id
            createdAt
            callType
            callName
            callDescription
            periodLength
            schedulePeriod
            recurring
            checkInType
            checkInTypeDays
        }
    }
`;
